<template>
  <div class="billing-preview">
    <h4 class="preview-title">Preview da Configuração</h4>

    <div class="preview-content">
      <div class="preview-item">
        <span class="label">Tipo de Cobrança:</span>
        <span class="value">{{ billingTypeLabel }}</span>
      </div>

      <div v-if="billingConfig.billing_type === 'fixed_value'" class="preview-item">
        <span class="label">Valor Mensal:</span>
        <span class="value highlight">{{ formatCurrency(billingConfig.billing_fixed_value) }}</span>
      </div>

      <div v-if="billingConfig.billing_type === 'per_active_user'" class="preview-item">
        <span class="label">Valor por Usuário:</span>
        <span class="value">{{ formatCurrency(billingConfig.billing_per_user_value) }}</span>
      </div>

      <div v-if="billingConfig.billing_type === 'per_active_user'" class="preview-item">
        <span class="label">Exemplo (50 usuários):</span>
        <span class="value highlight">
          {{ formatCurrency((billingConfig.billing_per_user_value || 0) * 50) }}
        </span>
      </div>

      <div v-if="billingConfig.billing_type === 'user_range' && billingConfig.billing_user_ranges?.length" class="preview-item">
        <span class="label">Faixas Configuradas:</span>
        <div class="ranges-list">
          <div
            v-for="(range, index) in billingConfig.billing_user_ranges"
            :key="index"
            class="range-preview"
          >
            {{ range.min }} - {{ range.max > 999999 ? '+' : range.max }} usuários:
            <strong>{{ formatCurrency(range.value) }}</strong>
          </div>
        </div>
      </div>

      <div class="preview-item">
        <span class="label">Período:</span>
        <span class="value">
          Dia {{ billingConfig.billing_period_start_day || 1 }}
          até
          {{ billingConfig.billing_period_end_day || 20 }}
        </span>
      </div>

      <div class="preview-item">
        <span class="label">Fechamento:</span>
        <span class="value">
          Dia {{ (billingConfig.billing_period_end_day || 20) + 1 }} de cada mês
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { BILLING_TYPE_LABELS } from '@constants/billing'

export default {
  name: 'BillingPreview',

  props: {
    billingConfig: {
      type: Object,
      required: true,
    },
  },

  computed: {
    billingTypeLabel() {
      return BILLING_TYPE_LABELS[this.billingConfig.billing_type] || 'Não configurado'
    },
  },

  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value || 0)
    },
  },
}
</script>

<style scoped>
.billing-preview {
  padding: 20px;
  border: 2px solid #28a745;
  border-radius: 8px;
}

.preview-title {
  margin-bottom: 15px;
  font-size: 1rem;
  font-weight: 600;
  color: #28a745;
}

.preview-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.preview-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.preview-item:last-child {
  border-bottom: none;
}

.preview-item .label {
  flex-shrink: 0;
  margin-right: 15px;
  font-weight: 500;
  color: #666;
}

.preview-item .value {
  color: #333;
  text-align: right;
}

.preview-item .value.highlight {
  font-size: 1.25rem;
  font-weight: 700;
  color: #28a745;
}

.ranges-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.range-preview {
  font-size: 0.875rem;
  text-align: right;
}
</style>
